<template>
  <div class="app p-0 m-0">
    <div>
      <MainMenu />
      <PopUp />
    </div>
    <div class="main pt-5">
      <router-view class="page-wrapper" />
    </div>
  </div>
</template>

<script>
import MainMenu from "../components/MainMenu.vue";
import PopUp from "../components/popups/PopUps.vue";
import VisitantForm from '../components/popups/VisitantForm.vue'

import WsSubscriptions from "../serve/websocket";
import { mapActions, mapGetters} from "vuex";

import Auth from "../utils/auth";


export default {
  name: "Home",
  components: { MainMenu, PopUp, VisitantForm },
  data() {
    return {
      ws_conection: null,
    };
  },
  computed: {
    ...mapGetters("user", ["userId"]),
  },
  async created() {
    this.setVisibilityVisitantForm(!Auth.loggedIn())
    if (!this.userId && Auth.authenticatedIn()) {
      try {
        await this.setUser();
        WsSubscriptions();
      } catch (error) {
  
        this.$router.push({
          name: "Exception",
          params: { mode: "connection" },
        });
      }
    }

    // console.log('Seta o WS')
    // this.ws_conection =  new WebSocket('ws://localhost:3333')

    // this.ws_conection.onopen = ((event) => {
    //   console.log('On opem =>  ',event)
    // })

    // this.ws_conection.onmessage = ((event) => {
    //   console.log('mensagem => ', event)
    // })
  },
  methods: {
    ...mapActions("user", ["setUser", 'setVisibilityVisitantForm']),

  },
};
</script>

<style lang="scss" scoped>
.app {
  // display: flex;
  background-color: #fafafa;
  flex-direction: row;
  height: 100%;
  overflow: inherit !important;

  .main {
    // background-color: #f8f9fa;
    width: 100vw;
    height: calc(100vh - 65px);

    overflow-x: auto;
    padding: 0 1rem 0 1rem;
  }
}
</style>